import type { ReactNode } from 'react';
import type { AuthStore } from '@/stores/AuthStore';
import { AuthStoreContext } from './store-context';

export function AuthStoreProvider({ store, children }: { store: AuthStore; children: ReactNode }) {
  return <AuthStoreContext.Provider value={store}>{children}</AuthStoreContext.Provider>;
}
